/**
 * 有盟埋点上报
 * _czc.push(["_trackEvent", category, action, label, value]);
 * 参数说明：
 * category: 事件分类，例如："deepSeek"
 * action: 事件动作，例如："openNow"
 * label: 事件标签，例如："click"
 * value: 事件值，例如："1"
 * @param {*} params []
 */
export const UMengTrack = (params) => {
  try {
    window._czc?.push(params);
  } catch (error) {
    console.error("UMengTrack error", error);
  }
};

/**
 * 获取有盟埋点ID
 * @returns
 */
export const UMengTrackId = () => {
  const domain = window.location.origin;
  if (domain.indexOf("alayanew.com") > -1) {
    return "1281395177";
  } else {
    return "1281394950";
  }
};

/**
 * 初始化有盟埋点
 */
export const UMengTrackInitScript = () => {
  const um = document.createElement("script");
  um.src = `https://s9.cnzz.com/z.js?id=${UMengTrackId()}&async=1`;
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(um, s);
};
